var styleDataHash = "c54ca4b7";
const injectCss = (() => {
  var css = `.M-59A{display:block;height:100%;width:100%}.M-59A img{max-width:var(--wix-img-max-width,100%)}.M-59A[data-animate-blur] img{filter:blur(9px);transition:filter .8s ease-in}.M-59A[data-animate-blur] img[data-load-done]{filter:none}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var Image_default = {
  "image": "M-59A"
};
export {
  Image_default as default,
  injectCss
};
//# sourceMappingURL=Image-scss.js.map
